/**
 * Logger de diagnóstico SOLO-desarrollo.
 *
 * Contrato: emite a la consola del navegador únicamente en dev
 * (`import.meta.env.DEV`); en producción es no-op — prod queda silencioso,
 * cero ruido para usuarios. Este es el único canal sancionado para logs de
 * diagnóstico en desarrollo (los `console.*` sueltos se limpian del repo).
 * El prefijo `[heru]` permite filtrar el ruido en la consola.
 */

const PREFIX = '[heru]';

const emit =
	(method: 'info' | 'warn' | 'error') =>
	(...args: unknown[]): void => {
		if (import.meta.env.DEV) console[method](PREFIX, ...args);
	};

export const logger = {
	info: emit('info'),
	warn: emit('warn'),
	error: emit('error'),
};
